










import { Component, Vue, Prop } from 'vue-property-decorator';
import { LookFullDTO } from '@/api';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';

@Component({
  name: 'look-actions-card',
  components: {
    LookDynamicCard,
  },
})
export default class LookActionCard extends Vue {
  @Prop(Object) look!: LookFullDTO;

  @Prop(Boolean) selected!: boolean;

  @Prop(Number) baseScale!: number;

  copy(e: Event) {
    this.$emit('copy', this.look, e);
  }

  remove(e: Event) {
    this.$emit('delete', this.look, e);
  }

  onClick(e: Event) {
    this.$emit('click', this.look, e);
  }
}
